import React, { Component } from "react";
import { getMovies } from "../../services/fakeMovieService";
import { getGenres } from "../../services/fakeGenreService";
import Pagination from "./Pagination";
import { paginate } from "../../utils/paginate";
import ListGroup from "./ListGroup";
import MoviesTable from "../MoviesTable";
import _ from "lodash";
import { Link } from "react-router-dom";
import SearchBox from "../SearchBox";

class Movies extends Component {
  constructor() {
    super();
    this.state = {
      movies: [],
      genres: [],
      pageSize: 4,
      searchQuery: "",
      selectedGenre: null,
      currentPage: 1,
      sortColumn: { path: "title", order: "asc" }
    };
  }

  componentDidMount() {
    const genres = [{ _id: "", name: "All Genres" }, ...getGenres()];
    this.setState({ movies: getMovies(), genres });
  }

  handleDelete = (id) => {
    const movies = this.state.movies.filter((prev) => id !== prev._id);
    this.setState({ movies });
  };
  handleClick = (movie) => {
    const movies = [...this.state.movies];
    const index = movies.indexOf(movie);
    movies[index] = { ...movies[index] };
    movies[index].liked = !movies[index].liked;
    this.setState({ movies });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleGenreSelect = (genre) => {
    this.setState({ selectedGenre: genre, searchQuery: "", currentPage: 1 });
  };
  handleSearch = (query) => {
    this.setState({ searchQuery: query, selectedGenre: null, currentPage: 1 });
  };
  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  getPageData = () => {
    const {
      pageSize,
      currentPage,
      sortColumn,
      searchQuery,
      movies: allMovies,
      selectedGenre
    } = this.state;

    let filtered = allMovies;
    if (searchQuery)
      filtered = allMovies.filter((m) =>
        m.title.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
    else if (selectedGenre && selectedGenre._id)
      filtered = allMovies.filter((m) => m.genre.name === selectedGenre.name);

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    const movies = paginate(sorted, currentPage, pageSize);

    return { totlaCount: filtered.length, data: movies };
  };

  render() {
    const { length: count } = this.state.movies;
    const { pageSize, currentPage, sortColumn } = this.state;

    if (count === 0)
      return (
        <p style={{ fontSize: 22, color: "#fff" }}>
          there are no movies in the dataBase
        </p>
      );

    const { totlaCount, data: movies } = this.getPageData();

    return (
      <div className="row" style={{ padding: 20 }}>
        <div className="col-3">
          <ListGroup
            items={this.state.genres}
            selectedItem={this.state.selectedGenre}
            onItemSelect={this.handleGenreSelect}
          />
        </div>
        <div className="col">
          <Link
            className="btn btn-primary"
            to="/movies/new"
            style={{ marginBottom: 20 }}
          >
            New Movie
          </Link>
          <p style={{ fontSize: 22 }}>
            {" "}
            showing {totlaCount} movies in the database.
          </p>
          <SearchBox value={this.searchQuery} onChange={this.handleSearch} />
          <MoviesTable
            movies={movies}
            sortColumn={sortColumn}
            onLike={this.handleClick}
            onDelete={this.handleDelete}
            onSort={this.handleSort}
          />
          <Pagination
            itemsCount={totlaCount}
            currentPage={currentPage}
            pageSize={pageSize}
            pageChange={this.handlePageChange}
          />
        </div>
      </div>
    );
  }

  // formatAlert() {
  //   let formatAlert = "alert ";
  //   formatAlert =
  //     +this.state.movies.length === 0 ? "alert-warning" : "alert-success";
  //   return formatAlert;
  // }

  // displayMessage() {
  //   const { count } = this.state.movies.length;
  //   return count === 0
  //     ? "there is no movie in the dataBase"
  //     : `there are ${count} movies in the database`;
  // }
}

export default Movies;
